module.exports = __webpack_public_path__ + "media/images/web_suite/resources_thumbs/featured-flashcard-deck-da88fb1cdb2a7cd5997a8243c0182936.png";